module.exports = __webpack_public_path__ + "static/media/tvLogo.3ba80247.svg";